import dashTypes from './dash.types';
import axios from 'axios';
import Socket from 'socket.io-client';
import storage from '../../helpers/storage';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `https://givemagic-test.herokuapp.com`;
} else {
  url = `https://givemagic-test.herokuapp.com`;
}

export default {
  fetchAnalytics({ commit }, data) {
    commit(dashTypes.FETCH_ANALYTICS_REQUEST);
    const ls = storage.get('manager');
    // var dateRange = {
    //   to: data.to,
    //   from: data.from
    // };

    const options = {
      url: `${url}/stats/admin`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
      data:{to: data.to, from: data.from}
    };
    axios(options)
      .then(res => {
        commit(dashTypes.FETCH_ANALYTICS_SUCCESS, {
          data: res.data.stats
        });
      })
      .catch(error => {
        commit(dashTypes.FETCH_ANALYTICS_FAILED, { error });
      });

  },
  fetchSentVideo({ commit },data) {
    const ls = storage.get('manager');
    commit(dashTypes.FETCH_DASHBOARDVIDEO_REQUEST);
    commit(dashTypes.FETCH_DASHBOARDVIDEO_REQUEST);


    const options = {
      url: `${url}/videos/all?type=sent&resultSize=12&page=${data}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };

    axios(options)
      .then(res => {
        // var responce = res.data.videos.docs
        // // const videos = responce.reverse()
        commit(dashTypes.FETCH_DASHBOARDVIDEO_SUCCESS, {
          fetchData: res.data.videos
        });
      })
      .catch(error => {
        commit(dashTypes.FETCH_DASHBOARDVIDEO_FAILED, { error });
      });
  },

  fetchPendingVideo({ commit },data) {
    const ls = storage.get('manager');
    commit(dashTypes.FETCH_PENDINGDVIDEO_REQUEST);


    const options = {
      url: `${url}/videos/all?type=not-approved&resultSize=12&page=${data}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };

    axios(options)
      .then(res => {
        // var responce = res.data.videos.docs
        // const videos = responce.reverse()
        commit(dashTypes.FETCH_PENDINGDVIDEO_SUCCESS, {
          fetchPendingData: res.data.videos
        });
      })
      .catch(error => {
        commit(dashTypes.FETCH_PENDINGDVIDEO_FAILED, { error });
      });
  },



  fetchVideoLibrary({ commit }, data) {
    const ls = storage.get('manager');
    commit(dashTypes.FETCH_VIDEOLIBRARY_REQUEST);
    const options = {
      url: `${url}/videos/all?type=library&resultSize=12&page=${data}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };

    axios(options)
      .then(res => {
        // var responce = res.data.videos.docs
        // const videos = responce.reverse()
        commit(dashTypes.FETCH_VIDEOLIBRARY_SUCCESS, {
          fetchlibraryData: res.data.videos
        });
      })
      .catch(error => {
        commit(dashTypes.FETCH_VIDEOLIBRARY__FAILED, { error });
      });
  },


  
  SendLibraryVideo({ commit }, data) {
    const ls = storage.get('manager');
    commit(dashTypes.SendLibraryVideo_Request);
    const options = {
      url: `${url}/videos/library/send`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
      data:data
    };
    axios(options)
      .then(res => {
        // var responce = res.data.videos.docs
        // const videos = responce.reverse()
        commit(dashTypes.SendLibraryVideo_Sucess);
      })
      .catch(error => {
        commit(dashTypes.SendLibraryVideo__FAILED, { error });
      });
  },





  deleteVideo({ commit }, data) {
    const ls = storage.get('manager');

    commit(dashTypes.DELETE_VIDEO_REQUEST);


    const options = {
      url: `${url}/videos/delete/${data}`,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };

    axios(options)
      .then(res => {
        commit(dashTypes.DELETE_VIDEO_SUCCESS, {
          data: res
        });
      })
      .catch(error => {
        commit(dashTypes.DELETE_VIDEO_FAILED, { error });
      });
  },

  rejectVideo({ commit }, data) {
    const ls = storage.get('manager');

    commit(dashTypes.DELETE_VIDEO_REQUEST);


    const options = {
      url: `${url}/videos/reject/${data}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };

    axios(options)
      .then(res => {
        commit(dashTypes.DELETE_VIDEO_SUCCESS, {
          res
        });
      })
      .catch(error => {
        commit(dashTypes.DELETE_VIDEO_FAILED, { error });
      });
  },


  
  approveVideo({ commit }, data) {
    const ls = storage.get('manager');
    commit(dashTypes.APPROVAL_VIDEO_REQUEST);
    const options = {
      url: `${url}/videos/approve/${data}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios(options)
      .then(res => {
        commit(dashTypes.APPROVAL_VIDEO_SUCCESS, {
          res
        });
      })
      .catch(error => {
        commit(dashTypes.APPROVAL_VIDEO_FAILED, { error });
      });
  },

  fetchWeeklyAnalytics({ commit }) {
    const ls = storage.get('manager');

    const options = {
      url: `${url}/workspace/weekly-uploads`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
    };
    axios(options)
      .then(res => {
        commit(dashTypes.FETCH_WEEKLY_SUCCESS, {
          weekly: res.data 
        });
      })
      .catch(error => {
          commit(dashTypes.FETCH_WEEKLY__FAILED, { error });
      });

  },
};